export default Object.freeze([
  'application/pdf',
  'image/jpeg',
  'image/tiff',
  'image/bmp',
  'image/gif',
  'image/png',
])
